// extracted by mini-css-extract-plugin
module.exports = {"IconLabelStatusError":"IconLabelStatusError_+rMCF"};